"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var customCheckboxStyles_1 = require("../customCheckboxStyles");
var CheckBox_1 = require("@material-ui/icons/CheckBox");
var CheckBoxOutlineBlank_1 = require("@material-ui/icons/CheckBoxOutlineBlank");
var RadioButtonUncheckedOutlined_1 = require("@material-ui/icons/RadioButtonUncheckedOutlined");
var CheckCircle_1 = require("@material-ui/icons/CheckCircle");
exports.ConsentSelectorCheckbox = function (_a) {
    var formData = _a.formData;
    var _b, _c;
    var styles = customCheckboxStyles_1.default();
    var value = formData.value, id = formData.id, onChange = formData.onChange;
    var handleChange = function (e) {
        onChange(e.target.checked);
    };
    var checkoutLite = core_1.useTheme().checkoutLite;
    var checkboxIconCircle = (_c = (_b = checkoutLite) === null || _b === void 0 ? void 0 : _b.enquiryForm) === null || _c === void 0 ? void 0 : _c.checkboxIconCircle;
    return (<core_1.Checkbox icon={checkboxIconCircle ? <RadioButtonUncheckedOutlined_1.default /> : <CheckBoxOutlineBlank_1.default />} checkedIcon={checkboxIconCircle ? <CheckCircle_1.default /> : <CheckBox_1.default />} color={'primary'} id={id} checked={!!value} value={value} size={'small'} onChange={handleChange} data-test={"checkbox:" + id} classes={{
        root: styles.root,
    }}/>);
};
exports.default = exports.ConsentSelectorCheckbox;
